import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "field", "warning", "timezone"]
  static values = {
    storedScheduledAt: String,
    scheduled: Boolean
  }

  connect() {
    this.toggleTarget.checked = this.scheduledValue
    this.fieldTarget.hidden = !this.scheduledValue

    // The server renders the value in its own zone. Tell it which zone the author
    // actually picked in, so the stored instant matches the clock they saw.
    if (this.hasTimezoneTarget) {
      this.timezoneTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone || ""
    }

    const input = this.#input()
    if (!input) return

    input.min = this.#toLocalInputValue(new Date())

    if (this.storedScheduledAtValue) {
      input.value = this.#toLocalInputValue(new Date(this.storedScheduledAtValue))
    }
  }

  toggle() {
    this.fieldTarget.hidden = !this.toggleTarget.checked

    const input = this.#input()
    if (this.toggleTarget.checked && input && input.value === "") {
      input.value = this.#defaultInputValue()
    }

    if (!this.toggleTarget.checked && input) {
      input.value = ""
    }

    if (this.hasWarningTarget) {
      this.warningTarget.hidden = this.toggleTarget.checked || !this.storedScheduledAtValue
    }
  }

  #input() {
    return this.fieldTarget.querySelector("input[type='datetime-local']")
  }

  #defaultInputValue() {
    const stored = this.storedScheduledAtValue ? new Date(this.storedScheduledAtValue) : null

    return this.#toLocalInputValue(stored || new Date())
  }

  // datetime-local expects a naive "YYYY-MM-DDTHH:MM" in the browser's own zone.
  #toLocalInputValue(date) {
    if (Number.isNaN(date.getTime())) return ""

    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000)

    return local.toISOString().slice(0, 16)
  }
}
